import { render, staticRenderFns } from "./SdkRecipients.vue?vue&type=template&id=3be8f9df&"
import script from "./SdkRecipients.vue?vue&type=script&lang=js&"
export * from "./SdkRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports